export default "__VITE_ASSET__BgfiMFJl__"